<template>
  <el-upload
    action="#"
    :show-file-list="false"
    :http-request="selectFile"
    accept=".p12,.pem,application/x-pkcs12"
    :disabled="disabled"
  >
    <i class="el-icon-upload2" />
    <span v-if="status">{{ status }}</span>
    <span v-else-if="value">
      {{ $t('CertificateUpload_UploadNewCertificate') }}
    </span>
    <span v-else>{{ $t('CertificateUpload_UploadCertificate') }}</span>
  </el-upload>
</template>

<script>
import { toBase64 } from '@/core/helpers'

export default {
  name: 'CertificateUpload',

  props: {
    value: {
      required: true
    },

    file: {
      required: true
    },

    password: {
      required: true
    },

    defaultPassword: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      status: null
    }
  },

  methods: {
    selectFile(option) {
      this.$prompt(
        this.$t('CertificateUpload_EnterCertificatePassword'),
        this.$t('CertificateUpload_CertificatePassword'),
        {
          inputType: 'text',
          inputValue: this.defaultPassword
        }
      )
        .then(({ value }) => {
          this.updateFile(option.file, value)
        })
        .catch(() => {
          this.resetFile()
        })
    },

    async updateFile(file, password) {
      this.status = file.name
      this.$emit('update:password', password)
      this.$emit('update:file', await toBase64(file))
    },

    resetFile() {
      this.status = null
      this.$emit('update:password', null)
      this.$emit('update:file', null)
    }
  }
}
</script>

<style scoped>
>>> .el-upload {
  height: 38px;
  line-height: 38px;
  width: 256px;
  border: 1px dashed #dbdee7;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
  white-space: nowrap;
}

>>> .el-upload:hover {
  background-color: #e6f3fb;
  border: 1px dashed #1d87c8;
  color: #1d87c8;
}

>>> .el-upload i {
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/CertificateUpload.vue